<template>
	<div>
		<HeaderBar title="临床事件"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<FormNormalInput label="事件名称" v-model="form.bq417.bq417003" />
				<van-cell-group title="">
					<StaticSingleSelect label="是否健在" :selectkey.sync="form.bq417.bq001032" :list="bq001032List">
					</StaticSingleSelect>

					<StaticSingleSelect v-show="form.bq417.bq001032=='死亡'" label="死亡原因"
						:selectkey.sync="form.bq417.bq0010323" :list="bq0010323List" style="margin-left: 1.5rem;">
					</StaticSingleSelect>
					<DateSelect v-show="form.bq417.bq001032=='死亡'" label="死亡时间" v-model="form.bq417.bq0010322" timeNow>
					</DateSelect>
					<!--          <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq001032}}</span>
              <span v-show="form.bq417.bq001032=='死亡'">
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq0010323}}
                </van-tag>
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq0010322}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>

				<van-cell-group title="">
					<StaticSingleSelect label="是否患肝癌" :selectkey.sync="form.bq417.bq417015" :list="booleanList" />
					<StaticSingleSelect v-show="form.bq417.bq417015=='是'" label="诊断依据"
						:selectkey.sync="form.bq417.bq4170153" :list="bq4170153List"  style="margin-left: 1.5rem;" />
					<FormNormalInput v-show="form.bq417.bq4170153=='其他'" label="其他原因" v-model="form.bq417.bq4170154" />
					<DateSelect v-show="form.bq417.bq417015=='是'" label="发生时间" v-model="form.bq417.bq4170152" timeNow />
					<!--          <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq417015}}</span>
              <span v-show="form.bq417.bq417015=='是'">
                <van-tag type="danger" v-show="form.bq417.bq4170153!='其他'" class="followRecord-tag">
                  {{form.bq417.bq4170153}}
                </van-tag>
                <van-tag type="danger" v-show="form.bq417.bq4170153=='其他'" class="followRecord-tag">
                  {{form.bq417.bq4170154}}
                </van-tag>
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170152}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>

				<van-cell-group title="">
					<StaticSingleSelect label="是否肝硬化" :selectkey.sync="form.bq417.bq417021" :list="booleanList" />
					<StaticSingleSelect v-show="form.bq417.bq417021=='是'" label="诊断依据"
						:selectkey.sync="form.bq417.bq4170213" :list="bq4170213List"  style="margin-left: 1.5rem;"/>
					<FormNormalInput v-show="form.bq417.bq4170213=='其他'" label="其他原因" v-model="form.bq417.bq4170214" />
					<DateSelect v-show="form.bq417.bq417021=='是'" label="发生时间" v-model="form.bq417.bq4170212" timeNow />
					<!--          <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq417021}}</span>
              <span v-show="form.bq417.bq417021=='是'">
                <van-tag type="danger" v-show="form.bq417.bq4170213!='其他'" class="followRecord-tag">
                  {{form.bq417.bq4170213}}
                </van-tag>
                <van-tag type="danger" v-show="form.bq417.bq4170213=='其他'" class="followRecord-tag">
                  {{form.bq417.bq4170214}}
                </van-tag>
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170212}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>

				<van-cell-group title="">
					<StaticSingleSelect label="肝衰竭" :selectkey.sync="form.bq417.bq417022" :list="booleanList" />
					<DateSelect v-show="form.bq417.bq417022=='是'" label="发生时间" v-model="form.bq417.bq4170222" timeNow />
					<!--        <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq417022}}</span>
              <span v-show="form.bq417.bq417022=='是'">
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170222}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>

				<van-cell-group title="">
					<StaticSingleSelect label="肝移植" :selectkey.sync="form.bq417.bq417023" :list="booleanList" />
					<DateSelect v-show="form.bq417.bq417023=='是'" label="发生时间" v-model="form.bq417.bq4170232" timeNow />
					<!--          <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq417023}}</span>
              <span v-show="form.bq417.bq417023=='是'">
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170232}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>

				<van-cell-group >
					<StaticSingleSelect label="其他恶性肿瘤" :selectkey.sync="form.bq417.bq417024" :list="booleanList" />
					<DateSelect v-show="form.bq417.bq417024=='是'" label="发生时间" v-model="form.bq417.bq4170242" timeNow />
					<!--          <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq417024}}</span>
              <span v-show="form.bq417.bq417024=='是'">
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170242}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>

				<van-cell-group>
					<StaticSingleSelect label="其他临床事件" :selectkey.sync="form.bq417.bq417025" :list="booleanList" />
					<FormNormalInput v-show="form.bq417.bq417025=='是'" label="描述" v-model="form.bq417.bq4170253" />
					<DateSelect v-show="form.bq417.bq417025=='是'" label="发生时间" v-model="form.bq417.bq4170252" timeNow />
					<!--          <van-cell>
            <template #title>
              <span class="followRecord-title">{{form.bq417.bq417025}}</span>
              <span v-show="form.bq417.bq417025=='是'">
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170253}}
                </van-tag>
                <van-tag type="danger" class="followRecord-tag">{{form.bq417.bq4170252}}
                </van-tag>
              </span>
            </template>
          </van-cell> -->
				</van-cell-group>
				<FormNormalUpload label="证明文件" ref="normalUpload" :infoGuid='form.bq417.guid' :disabled="disabled">
				</FormNormalUpload>
				<div class="page-bottom-box" style="margin: 16px;" v-show="!disabled">
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq417.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>

			</van-form>
		</div>
	</div>
</template>


<script>
	// import bus from '../bq400/page/js/eventBus.js'
	export default {
		name: 's400Bq417Form',
		data() {
			return {
				form: {
					bq417: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						bq001018: "", //患者编号
						bq417003: "", //事件名称
						bq001032: "健在", //是否健在 健在，死亡
						bq0010322: "", //死亡时间
						bq0010323: "", //死亡原因 1、肝病相关死亡  2、非肝病相关死亡
						bq417015: "否", //是否肝癌 是，否
						bq4170152: "", //诊断时间
						bq4170153: "", //诊断依据
						bq4170154: "", //其他原因
						bq417021: "否", //是否肝硬化 是，否
						bq4170212: "", //发生时间
						bq4170213: "", //肝硬化类型
						bq4170214: "", //其他原因
						bq417022: "否", //肝衰竭 是，否
						bq4170222: "", //发生时间
						bq4170223: "", //并发症类型
						bq417023: "否", //肝移植 是、否
						bq4170232: "", //发生时间
						bq417024: "否", //HBsAg清除 是、否
						bq4170242: "", //发生时间
						bq417025: "否", //其他严重并发症 是、否
						bq4170252: "", //发生时间
						bq4170253: "", //描述
						bq400guid: "", //随访编号
						bq400title: "", //临床事件显示的所属随访名称
						Bq001_018: '', //患者编号
						Bq001_032: '', //是否健在 健在，死亡
						Bq001_032_2: '', //死亡时间
						Bq001_032_3: '', //死亡原因 1、肝病相关死亡  2、非肝病相关死亡
						Bq417_015: '', //是否肝癌 是，否
						Bq417_015_2: '', //诊断时间
						Bq417_015_3: '', //诊断依据
						Bq417_021: '', //是否肝硬化 是，否
						Bq417_021_2: '', //发生时间
						Bq417_021_3: '', //诊断依据
						Bq417_021_4: '', //其他原因说明
						Bq417_022: '', //是否肝衰竭 是，否
						Bq417_022_2: '', //发生时间
						Bq417_022_3: '', //并发症类型 暂不用
						Bq417_023: '', //肝移植 是、否
						Bq417_023_2: '', //发生时间
						Bq417_024: '', //其他系统恶性肿瘤 是、否
						Bq417_024_2: '', //发生时间
						Bq417_025: '', //其他严重并发症 是、否
						Bq417_025_2: '', //发生时间
						Bq417_025_3: '', //描述
						Bq417_003: '', //事件名称
						Bq400_guid: '', //随访编号
						Bq417_015_4: '', //其他原因说明
						Bq400_title: '', //临床事件名称
					},
					sempFiles: [],
				},
				has: {
					hasBq417: '无',
				},

				// 健在
				bq001032List: [],
				// 死亡原因
				bq0010323List: [],
				// boolean数组
				booleanList: [],
				// 肝癌诊断依据
				bq4170153List: [],
				// 肝硬化诊断依据
				bq4170213List: [],


				fullscreenLoading: false,
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq417/Save',
				bq400: JSON.parse(sessionStorage.getItem('bq400'))
			}

		},
		// 接收父页面传入的对象
		props: {
			bq001: {
				type: Object
			},
			bq417Id: {
				type: Number,
				default: 0
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		methods: {
			//保存按钮成功回调事件
			saveSucess: function() {
				//调用列表页的closeDialog方法
				// this.Back()
				this.$emit("closePage", "")
			},

			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq417/Info', args, function(d) {
					let dataModel = d.Data
					if (dataModel != null) {
						that.$utils.CopyKeyInfo(dataModel, dataModel)
						that.$utils.CopyPro(dataModel, that.form.bq417)
						if(that.form.bq417.bq0010322!=null){
							that.form.bq417.bq0010322 =(that.form.bq417.bq0010322+'').substring(0,10)
						}
						if(that.form.bq417.bq4170152!=null){
							that.form.bq417.bq4170152 =(that.form.bq417.bq4170152+'').substring(0,10)
						}
						if(that.form.bq417.bq4170212!=null){
							that.form.bq417.bq4170212 =(that.form.bq417.bq4170212+'').substring(0,10)
						}
						if(that.form.bq417.bq4170222!=null){
							that.form.bq417.bq4170222 =(that.form.bq417.bq4170222+'').substring(0,10)
						}
						if(that.form.bq417.bq4170232!=null){
							that.form.bq417.bq4170232 =(that.form.bq417.bq4170232+'').substring(0,10)
						}
						if(that.form.bq417.bq4170242!=null){
							that.form.bq417.bq4170242 =(that.form.bq417.bq4170242+'').substring(0,10)
						}
						if(that.form.bq417.bq4170252!=null){
							that.form.bq417.bq4170252 =(that.form.bq417.bq4170252+'').substring(0,10)
						}
					}
				}, null, null, null);
			},
			//重新整理数据
			ResetData: function() {
				if (this.form.bq417.bq001032 == '健在') {
					this.form.bq417.bq0010322 = ''
					this.form.bq417.bq0010323 = ''
				}
				if (this.form.bq417.bq417015 == '否') {
					this.form.bq417.bq4170152 = ''
					this.form.bq417.bq4170153 = ''
					this.form.bq417.bq4170154 = ''
				}
				if (this.form.bq417.bq417021 == '否') {
					this.form.bq417.bq4170212 = ''
					this.form.bq417.bq4170213 = ''
					this.form.bq417.bq4170214 = ''
				}
				if (this.form.bq417.bq417022 == '否') {
					this.form.bq417.bq4170222 = ''
					this.form.bq417.bq4170223 = ''
				}
				if (this.form.bq417.bq417023 == '否') {
					this.form.bq417.bq4170232 = ''
				}
				if (this.form.bq417.bq417024 == '否') {
					this.form.bq417.bq4170242 = ''
				}
				if (this.form.bq417.bq417025 == '否') {
					this.form.bq417.bq4170252 = ''
					this.form.bq417.bq4170253 = ''
				}

			},
			//保存信息
			SaveInfo: function() {
				let that = this
				that.ResetData()
				that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.form.bq417.bq400title = that.bq400.bs025003 + ' / ' + that.bq400.bq400995
				that.$utils.CopyKeySave(that.form.bq417, that.form.bq417)
				that.$refs.btnSave.Save()
			},

		},
		mounted() {
			let that = this

			// 预处理下拉数组
			that.bq001032List = that.$utils.setStandardList(that.$apis.s400Apis.bq001032List)
			that.bq0010323List = that.$utils.setStandardList(that.$apis.s400Apis.bq0010323List)
			that.booleanList = that.$utils.setStandardList(that.$apis.s400Apis.booleanList)
			that.bq4170153List = that.$utils.setStandardList(that.$apis.s400Apis.bq4170153List)
			that.bq4170213List = that.$utils.setStandardList(that.$apis.s400Apis.bq4170213List)

			that.form.bq417.bq001018 = that.bq400.bq001018
			that.form.bq417.bq400guid = that.bq400.guid
			that.LoadInfo()
		}
	}
</script>

<style scoped>
	.followRecord-title {
		padding-right: 10px;
	}

	.followRecord-tag {
		margin-right: 10px;
	}
</style>
